import Story from "../../components/games/story/Story"
import ChooseStory from "../../components/games/story/ChooseStory"
import { useState, useEffect } from "react"
import { api } from "../../services/api"
import { useParams } from "react-router"
import { useTranslation } from "react-i18next"

import React from "react"
import Container from "../../components/ui/Container"
import { asciify } from "../../helpers/utils"
import toast from "react-hot-toast"

const StoryReverseSearch = ({ asciiedTitle }) => {
  const [data, setData] = useState(false)
  const [err, setErr] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    const { url, opt } = api.stories.reverseSearch({ asciiedTitle })
    fetch(url, opt)
      .then((res) => {
        if (res.status !== 200) {
          setErr(res.status !== 200)
          toast.error(t(`ui.games.msgs.error`))
        }
        return res.json()
      })
      .then((d) => {
        setData(d)
      })
    // eslint-disable-next-line
  }, [])

  if (!data) return <>{t(`ui.games.msgs.loading`)}</>

  if (err) return <>{t(`ui.games.msgs.error`)}</>

  return <Story chosenStory={data.id} />
}

const StoryView = () => {
  const [chosenStory, setChosenStory] = useState(undefined)
  const [storyList, setStoryList] = useState(undefined)

  const chooseRandom = () => {
    setChosenStory("undefined")
  }

  useEffect(() => {
    const { url, opt } = api.games.Story.listStories()
    fetch(url, opt)
      .then((res) => res.json())
      .then((d) => {
        setStoryList(d.entries)
      })
  }, [])

  const { uid } = useParams()

  return (
    <Container>
      {uid ? (
        <StoryReverseSearch asciiedTitle={asciify(uid).toLowerCase()} />
      ) : (
        storyList &&
        (chosenStory ? (
          <Story chosenStory={chosenStory} />
        ) : (
          <ChooseStory
            setChosenStory={setChosenStory}
            storyList={storyList.filter((s) => s.public)}
            alAzarCallback={chooseRandom}
          />
        ))
      )}
    </Container>
  )
}

export default StoryView
